import { useFormContext } from 'react-hook-form';
import { PackagesFormValues } from '../../types';

export const useGuestExperiences = () => {
  const { watch } = useFormContext<PackagesFormValues>();
  const guests = watch('guests') || [];

  return guests.map((g) => ({ bookings: g.experiences || [] }));
};
